import React from 'react';
import { addDays, addHours, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';

import DatePicker from '../../../Common/DatePicker';

export const EndDate: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { selectedForm, endDate } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepPrevEndDate">
      {selectedForm === 1 && <h3>{t('manageContracts:manageContracts.OldDateTitleForm1')}*</h3>}
      {selectedForm === 3 && <h3>{t('manageContracts:manageContracts.OldDateTitleForm3')}*</h3>}

      <p>{t('manageContracts:manageContracts.OldDateBody')}</p>

      <DatePicker
        type="single"
        day={{ date: endDate, setDate: () => dispatch(['changeEnd', endDate]) }}
        limits={{ minDate: addDays(new Date(), 5), maxDate: new Date('2026-09-30') }}
        onDateChange={(endDate): void => {
          if (endDate) {
            endDate = addHours(startOfDay(endDate), 12);
          }
          dispatch(['changeEnd', endDate]);
        }}
      />
    </section>
  );
};

export default EndDate;
